import React, { useState } from "react";

import "easymde/dist/easymde.min.css";
import { useTranslation } from "react-i18next";

import VASTForm from "./VASTForm";
import "../../css/admin/utils/item-status.scss";
import { StatusEnum } from "../../types";
import ItemStatus from "../../utils/ItemStatus";
import ContainerHeader from "../utils/ContainerHeader";

import type { JSX } from "react";

import type { IAdvertisingSingle, VASTFormValue } from "../../types";

interface Props {
  campaign: IAdvertisingSingle;
  onSubmit: (item: IAdvertisingSingle, onSuccess?: () => void) => void;
}

function VASTCampaignForm({ campaign, onSubmit }: Props): JSX.Element {
  const { t } = useTranslation("editor-advertisings");
  const [campaignState, setCampaignState] = useState(campaign);

  const handleChangeTitle = (target: HTMLInputElement): void => {
    const updatedCampaign = {
      ...campaignState,
      label: target.value,
    };

    setCampaignState(updatedCampaign);
  };

  const handleChangeState = (enabled: boolean): void => {
    const updatedCampaign = {
      ...campaignState,
      status: enabled ? StatusEnum.ENABLED : StatusEnum.DISABLED,
    };
    setCampaignState(updatedCampaign);
  };

  const handleChange = ({
    key,
    value,
  }: {
    key: keyof IAdvertisingSingle;
    value: VASTFormValue;
  }): void => {
    const updatedCampaign = {
      ...campaignState,
      [key]: value,
    };

    setCampaignState(updatedCampaign);
  };

  return (
    <div className="editor-smartlist-form-container editor-has-breadcrumbs">
      <ContainerHeader
        withBackBtn
        defaultLabel={t("unamed")}
        item={campaignState}
        itemStatus={ItemStatus.getAdvertisingStatus(campaignState)}
        onChangeLabel={handleChangeTitle}
        onChangeState={handleChangeState}
        onSave={(): void => onSubmit(campaignState)}
      />
      <VASTForm advertisingCampaign={campaignState} onChange={handleChange} />
    </div>
  );
}

export default VASTCampaignForm;
